var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsEnum, IsString, ValidateNested } from 'class-validator';
import { ReviewHintSource } from '../enums/review-hint-source.enum.js';
/** One entry of `massnahmen`: exactly one per Heilmittel of the appointment (Schema v2). */
export class AiDraftMeasureDto {
    heilmittel;
    text;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AiDraftMeasureDto.prototype, "heilmittel", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AiDraftMeasureDto.prototype, "text", void 0);
/**
 * The content fields of Schema v2 (TM-9574, Spec § 3.5) — what a draft
 * carries as `payload` and what the saved item stores as its edited copy.
 * `pruefhinweise` is deliberately not part of it: review hints live in
 * {@link ReviewHintDto} and are never saved. The German keys are the schema
 * contract with the model and stay German (map Notes).
 */
export class AiDraftPayloadDto {
    subjektiv;
    objektiv;
    massnahmen;
    reaktion;
    vorgehen;
    nichtZugeordnet;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AiDraftPayloadDto.prototype, "subjektiv", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AiDraftPayloadDto.prototype, "objektiv", void 0);
__decorate([
    Expose(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => AiDraftMeasureDto),
    __metadata("design:type", Array)
], AiDraftPayloadDto.prototype, "massnahmen", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AiDraftPayloadDto.prototype, "reaktion", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AiDraftPayloadDto.prototype, "vorgehen", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AiDraftPayloadDto.prototype, "nichtZugeordnet", void 0);
/** A hint shown above the draft in the review UI (Spec § 3.5). */
export class ReviewHintDto {
    source;
    text;
}
__decorate([
    Expose(),
    IsEnum(ReviewHintSource),
    __metadata("design:type", String)
], ReviewHintDto.prototype, "source", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], ReviewHintDto.prototype, "text", void 0);
//# sourceMappingURL=ai-draft-payload.dto.js.map